import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Utilerias } from 'src/app/helpers/Utilerias';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { Estacion, Negocios, Region } from 'src/app/types/Entitys';
import { EtapaRevision, TipoRevision } from 'src/app/types/type';

@Component({
  selector: 'app-form-cartera-revisones',
  templateUrl: './form-cartera-revisones.component.html',
  styleUrls: ['./form-cartera-revisones.component.css']
})
export class FormCarteraRevisonesComponent {
  @Input() negocioUsuario: number;
  @Input() tipoRevisiones: TipoRevision[];
  @Input() etapas: EtapaRevision[];
  @Output() emitSearch = new EventEmitter();
  regiones: Region[];
  estaciones: Estacion[];
  form: FormGroup;
  descriptionRegionSitio: string = 'Estación/Sitio';

  constructor(private formBuilder: FormBuilder, private userService: UsuariosService) {
    this.buildForm()
  }

  buildForm() {
    this.form = this.formBuilder.group({
      folio: [''],
      region: [0],
      estacion: [0],
      etapa: [0],
      tipoRevision: [0],
      fechaInicioReal: [''],
      fechaFinReal: [''],
      fechaInicioPlaneada: [''],
      fechaFinPlaneada: [''],
    });

    this.setCatalogoRegiones(this.negocioUsuario);
  }

  formSearchHandler() {
    if (this.form.valid) {
      const {
        folio,
        negocio,
        region,
        estacion,
        etapa,
        tipoRevision,
        fechaInicioReal,
        fechaFinReal,
        fechaInicioPlaneada,
        fechaFinPlaneada
      } = this.form.value;

      this.emitSearch.emit({
        IdRevision: folio,
        Negocio_Id: negocio,
        IdRegion: region,
        IdEstacion: estacion,
        IdEtapa: etapa,
        IdTipoRevision: tipoRevision,
        FechaInicioReal: fechaInicioReal,
        FechaFinReal: fechaFinReal,
        FechaInicioPlan: fechaInicioPlaneada,
        FechaFinPlan: fechaFinPlaneada
      });
    }
  }

  changeNegocio(event: Event) {
    const inpunt = event.target as HTMLInputElement;
    const idNegocio = parseInt(inpunt.value)

    if (idNegocio === 1)
      this.descriptionRegionSitio = 'Estación';
    else if (idNegocio === 2 || idNegocio === 3)
      this.descriptionRegionSitio = 'Sitios';

    this.userService.getCatalogoRegiones({ Negocio_Id: idNegocio })
      .subscribe(resp => {
        if (resp?.Result?.Exito) {
          this.regiones = resp.Result.Data as Region[]
          this.form.patchValue({ estacion: '0' })
        }
        else
          Utilerias.alertClient('', resp?.Result?.Error, 1);
      })
  }

  changeRegion(event: Event) {
    const inpunt = event.target as HTMLInputElement;
    const idRegion = parseInt(inpunt.value)
    this.userService.getEstaciones(idRegion)
      .subscribe(resp => {
        if (resp?.Result?.Exito)
          this.estaciones = resp.Result.Data as Estacion[]
      })
  }

  validForm(): boolean {
    return Object.values(this.form.value).some(field => field !== 0 && field !== '' && field !== null);
  }

  setCatalogoRegiones(idNegocio: number) {
    this.userService.getCatalogoRegiones({ Negocio_Id: idNegocio })
    .subscribe(resp => {
      if (resp?.Result?.Exito) {
        this.regiones = resp.Result.Data as Region[]
        this.form.patchValue({ estacion: '0' })
      }
      else
        Utilerias.alertClient('', resp?.Result?.Error, 1);
    })
  }
}
